<template>
    <div>
        <div class="section">
            <img src="https://s20.lgstatic.com/growth/activity/20220505/1651731703901.png" alt="">
            <img v-if="selectedSubjectId" @click="openWeapp" class="add-btn" src="https://s20.lgstatic.com/growth/activity/20220505/1651739273628.png" alt="">
            <img v-else class="add-btn" src="https://s20.lgstatic.com/growth/activity/20220505/1651739221022.png" alt="">
            <div class="subject-container">
                <div class="subject-title">选择以下对应学科 领取资料</div>
                <div class="subject-list">
                    <div
                        v-for="subject in subjectLis"
                        :class="['subject-item', selectedSubjectId === subject.subjectId && 'actived']"
                        :key="subject.subjectId"
                        @click="selectSubjectFn(subject)"
                    >
                        <div class="subject-item-inner">{{subject.subjectName}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section">
            <img src="https://s20.lgstatic.com/growth/activity/20220513/1652411012239.jpg" alt="">
            <!-- <img
                v-if="!privateCourseCoupon.alreadyReceive"
                class="coupon-receive-left"
                src="https://s20.lgstatic.com/growth/activity/20220505/1651736250442.png"
                @click="receivePrivateCourseCoupon('520-优惠券领取')"
            >
            <img v-else class="coupon-receive-left" src="https://s21.lgstatic.com/growth/activity/20220505/1651736379671.png">
            <img
                v-if="!trainingCampCoupon.alreadyReceive"
                class="coupon-receive-right"
                src="https://s20.lgstatic.com/growth/activity/20220505/1651736250442.png"
                @click="showTrainingCampCoupon('1314-优惠券领取')"
            >
            <img v-else class="coupon-receive-right" src="https://s21.lgstatic.com/growth/activity/20220505/1651736379671.png"> -->
            <img
                v-if="!trainingCampCoupon.alreadyReceive"
                class="coupon-receive-middle"
                src="https://s20.lgstatic.com/growth/activity/20220505/1651736250442.png"
                @click="showTrainingCampCoupon('1314-优惠券领取')"
            >
            <img v-else class="coupon-receive-middle" src="https://s21.lgstatic.com/growth/activity/20220505/1651736379671.png">
        </div>
        <div class="section">
            <img src="https://s21.lgstatic.com/growth/activity/20220516/1652667266307.jpg" alt="">
            <img class="order-btn" @click="handleGoForm('96e584784cb94c178ea397db3e409117', '立即预约私教名额', 'page')" src="https://s21.lgstatic.com/growth/activity/20220505/1651736476324.png" alt="">
        </div>
        <div class="section">
            <img src="https://s20.lgstatic.com/growth/activity/20220505/1651731787370.png" alt="">
            <div class="study-container">
                <img class="study-img study-img-1"  @click="handleTrainClick('ec5e7096784f4c12acb30509179da508', `1314-数据分析`)" src="https://s20.lgstatic.com/growth/activity/20220505/1651736779529.png" alt="">
                <img class="study-img study-img-2"  @click="handleTrainClick('f331871ccf91414896e61eacd84d1429', `1314-产品`)" src="https://s20.lgstatic.com/growth/activity/20220505/1651736779529.png" alt="">
                <img class="study-img study-img-3"  @click="handleTrainClick('60424ceaa6ca449983ec6b88cb4ab337', `1314-前端`)" src="https://s20.lgstatic.com/growth/activity/20220505/1651736779529.png" alt="">
                <img class="study-img study-img-4"  @click="handleTrainClick('0279ee5641134bdd9c792ccdf89d319f', `1314-测试`)" src="https://s20.lgstatic.com/growth/activity/20220505/1651736779529.png" alt="">
                <img class="study-img study-img-5"  @click="handleTrainClick('d68a28c6a455442fbace617b3d27dc54', `1314-Java`)" src="https://s20.lgstatic.com/growth/activity/20220505/1651736779529.png" alt="">
                <img class="study-img study-img-6"  @click="handleTrainClick('b81a5c0d7dc94c3f88de261065ea56b3', `1314-运营`)" src="https://s20.lgstatic.com/growth/activity/20220505/1651736779529.png" alt="">
                <img class="study-img study-img-7"  @click="handleTrainClick('b9bbe7ae829f4480bc0d860ebf2b1970', `1314-大数据`)" src="https://s20.lgstatic.com/growth/activity/20220505/1651736779529.png" alt="">
            </div>
        </div>
        <div class="section">
            <img src="https://s21.lgstatic.com/growth/activity/20220510/1652171096284.png" alt="">
            <div class="swiper-container current-wrap">
                <div class="swiper-wrapper current-wraps">
                    <div
                        v-for="(value,inde) in sectionSwiper"
                        :key="inde"
                        class="swiper-slide current-box"
                    >
                        <img class="company" :src="value"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="section">
            <img src="https://s21.lgstatic.com/growth/activity/20220505/1651731815658.png" alt="">
        </div>
        <div class="section">
            <img src="https://s21.lgstatic.com/growth/activity/20220505/1651731835376.png" alt="">
        </div>
        <div class="section fixed">
            <img  @click="handleGoForm('96e584784cb94c178ea397db3e409117', `立即领取 大厂涨薪攻略`, 'page')" src="https://s21.lgstatic.com/growth/activity/20220505/1651731847682.png" alt="">
        </div>
        <div v-if="receviceCouponModal" class="recevice-coupon">
            <div class="recevice-coupon-content">
                <div class="recevice-coupon-wrap">
                    <img class="recevice-coupon-img" src="https://s21.lgstatic.com/growth/activity/20220328/1648461576793.png">
                    <div class="subject-list">
                        <div
                            :class="{
                                'subject-item': true,
                                'actived': selectSubject == subject.type
                            }"
                            v-for="subject in subjectList"
                            :key="subject.type"
                            @click="handleSelectedSubject(subject.type)"
                        >{{subject.subjectName}}</div>
                    </div>
                </div>
                <div class="recevice-coupon-btn" @click="receiveTrainingCampCoupon">领取￥1314优惠券</div>
                <div class="close-btn" @click="receviceCouponModal = false"></div>
            </div>
        </div>
        <div v-if="receviceSuccessModal" class="recevice-success">
            <div class="recevice-content">
                <div class="recevice-wrap">
                    <img class="recevice-img" src="https://s20.lgstatic.com/growth/activity/20220328/1648454452724.png">
                    <div class="recevice-txt">优惠券已发送您 {{userLoginAccount}} 账户</div>
                </div>
                <div class="learn-btn" @click="goDetail">查看学科资料</div>
                <div class="later-btn" @click="receviceSuccessModal = false">稍后查看</div>
            </div>
        </div>
        <div v-if="qrcodeModal" class="qrcode-modal">
            <div class="qrcode-content">
                <img class="close" @click="qrcodeModal = false" src="https://s21.lgstatic.com/growth/activity/20220510/1652153737078.png" alt="">
                <img class="qrcode-img" :src="qrCodeImgUrl" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.css';
import * as Cookies from 'js-cookie';
import { getBigCourseCoupon, receiveBigCourseCoupon, privateEducationV2, fetchUserInfo } from '../../../service/api'
import { handleJumpUrl } from '../../../uitl/getParam.js';
import { getEduAppVersion, isBiggerThanSpecifiedVersion } from '../../../uitl/getVersion';
import share from '../../../common/js/share';
export default {
    data() {
        return {
            subjectLis: [
                { subjectName: 'Java', subjectId: 1 },
                { subjectName: '前端', subjectId: 2 },
                { subjectName: '大数据', subjectId: 3 },
                { subjectName: '数据分析', subjectId: 4 },
                { subjectName: '产品', subjectId: 5 },
                { subjectName: '测试', subjectId: 6 },
            ],
            selectedSubjectId: '',
            subjectList: [
                { type: 1, subjectName: "Java", imgUrl: 'https://s21.lgstatic.com/growth/activity/20220331/1648709857214.png',url: 'https://edu.lagou.com/growth/sem/java_architect.html', formId: 'd68a28c6a455442fbace617b3d27dc54' },
                { type: 2, subjectName: "前端", imgUrl: 'https://s21.lgstatic.com/growth/activity/20220331/1648709872346.png',url: 'https://edu.lagou.com/growth/sem/fe-next.html', formId: '60424ceaa6ca449983ec6b88cb4ab337' },
                { type: 3, subjectName: "大数据", imgUrl: 'https://s21.lgstatic.com/growth/activity/20220331/1648709884836.png',url: 'https://edu.lagou.com/growth/sem/data_enhancement.html', formId: 'b9bbe7ae829f4480bc0d860ebf2b1970' },
                { type: 4, subjectName: "数据分析", imgUrl: 'https://s21.lgstatic.com/growth/activity/20220331/1648709822126.png',url: 'https://edu.lagou.com/growth/sem/data_analysis.html', formId: 'ec5e7096784f4c12acb30509179da508' },
                { type: 5, subjectName: "产品", imgUrl: 'https://s21.lgstatic.com/growth/activity/20220331/1648709914157.png',url: 'https://edu.lagou.com/growth/sem/pm__enhancement.html', formId: 'f331871ccf91414896e61eacd84d1429' },
                { type: 6, subjectName: "测试", imgUrl: 'https://s21.lgstatic.com/growth/activity/20220331/1648709900045.png',url: 'https://edu.lagou.com/growth/sem/test_engineer.html', formId: '0279ee5641134bdd9c792ccdf89d319f' },
                // { type: 7, subjectName: "运营", imgUrl: 'https://s20.lgstatic.com/growth/activity/20220331/1648709925863.png',url: 'https://edu.lagou.com/growth/sem/all_operate.html', formId: 'b81a5c0d7dc94c3f88de261065ea56b3' }
            ],
            qrCodeImg: [
                // JAVA
                'https://s21.lgstatic.com/growth/activity/20220510/1652164350528.png',
                // 前端
                'https://s21.lgstatic.com/growth/activity/20220510/1652164375362.png',
                // 大数据
                'https://s21.lgstatic.com/growth/activity/20220510/1652164350528.png',
                // 数据分析
                'https://s21.lgstatic.com/growth/activity/20220510/1652164419375.png',
                // 产品
                'https://s20.lgstatic.com/growth/activity/20220510/1652164326942.png',
                // 测试
                'https://s21.lgstatic.com/growth/activity/20220510/1652164375362.png'
            ],
            privateCourseCoupon: {},
            trainingCampCoupon: {},
            userInfo: {},
            userLoginAccount: '',
            currentDraw: 13,
            selectSubject: '',
            receviceCurrent: false,
            receviceCouponModal: false,
            receviceSuccessModal: false,
            receviceSuccessModal2: false,
            showError: false,
            errorMessage: '',
            qrcodeModal: false,
            qrCodeImgUrl: '',
            sectionSwiper: [
                "https://s21.lgstatic.com/growth/activity/20220510/1652171410844.png",
                "https://s20.lgstatic.com/growth/activity/20220510/1652171436496.png",
                "https://s20.lgstatic.com/growth/activity/20220510/1652171443291.png",
                "https://s20.lgstatic.com/growth/activity/20220510/1652171451677.png",
                "https://s21.lgstatic.com/growth/activity/20220510/1652171458225.png",
            ],
            isAndroid: navigator.userAgent.indexOf('Android') !== -1,
        }
    },
    watch: {
        showError: function(newVal, oldVal) {
            if (newVal) {
                setTimeout(() => {
                    this.showError = false;
                }, 3000)
            }
        }
    },
    created () {
        this.saLogin();
        if (Cookies.get('gate_login_token') || Cookies.get('edu_gate_login_token')) {
          this.initCouponStatus();
        }
    },
    mounted () {
        this.initShare();
        let option1 = {
            direction: 'horizontal',
            loop: true,
            speed: 1500,
            paginationType: 'bullets',
            paginationClickable: true,
            autoplayDisableOnInteraction: false,
            autoplay: 3000,
            slidesPerView: 'auto',
            centeredSlides: false,
            spaceBetween: 12,
        };
        this.$nextTick(() => {
            const swiper = new Swiper('.current-wrap', option1);
        });
    },
    methods: {
        initShare() {
            const shareMsg = {
                title: '喊你免费领礼品啦～',
                desc: '6天礼品狂送，快来点击领取>>>',
                imgUrl: 'https://s21.lgstatic.com/growth/activity/20220415/1649990517124.png'
            };
            share.init(shareMsg);
        },
        initCouponStatus() {
            getBigCourseCoupon().then(res => {
                if (res.state == 1) {
                    this.privateCourseCoupon = res.content.privateCourseCoupon || {};
                    this.trainingCampCoupon = res.content.trainingCampCoupon || {};
                }
            })
            fetchUserInfo().then(res => {
                if (res.state == 1) {
                    this.userInfo = res.content || {};
                }
            })
        },
        receivePrivateCourseCoupon(buttonName) {
            this.eduPlatTrackFn(buttonName);
            if (!Cookies.get('gate_login_token') && !Cookies.get('edu_gate_login_token')) {
                return window.open('/frontLogin.do', '_self');
            }
            this.selectSubject = '';
            const data = {
                couponNo: this.privateCourseCoupon.couponNo || '',
                subjectId: ''
            }
            this.receiveBigCourseCouponFn(data);
        },
        showTrainingCampCoupon(buttonName) {
            this.eduPlatTrackFn(buttonName);
            if (!Cookies.get('gate_login_token') && !Cookies.get('edu_gate_login_token')) {
                return window.open('/frontLogin.do', '_self');
            }
            this.selectSubject = '';
            this.receviceCouponModal = true;
        },
        receiveTrainingCampCoupon() {
            if (!this.selectSubject) {
                this.errorMessage = '请选择学科';
                this.showError = true;
                return;
            }
            const buttonName = `领取￥1314优惠券-${this.subjectList[this.selectSubject - 1].subjectName}`;
            this.eduPlatTrackFn(buttonName);
            const data = {
                couponNo: this.trainingCampCoupon.couponNo,
                subjectId: this.selectSubject
            }
            this.receiveBigCourseCouponFn(data);
        },
        receiveBigCourseCouponFn(data) {
            receiveBigCourseCoupon(data).then(res => {
                if (res.state == 1) {
                    this.userLoginAccount =  res.content.userLoginAccount || '';
                    this.receviceSuccessModal = true;
                    this.initCouponStatus();
                } else {
                    this.errorMessage = res.message;
                    this.showError = true;
                }
            }).finally(() => {
                this.receviceCouponModal = false;
            })
        },
        handleSelectedSubject(type) {
            this.selectSubject = type;
        },
        handleTrainClick(formId, buttonName) {
            this.eduPlatTrackFn(buttonName);
            handleJumpUrl(formId);
        },
        goDetail() {
            this.eduPlatTrackFn('查看学科资料');
            if (!this.selectSubject) {
                window.location.href = 'https://edu.lagou.com/growth/sem/offer.html';
            } else {
                window.location.href = this.subjectList[this.selectSubject - 1].url;
            }
        },
        handleGoForm(key, buttonName, type) {
            this.eduPlatTrackFn(buttonName);
            if (type == 'page') {
                window.location.href = 'https://edu.lagou.com/growth/sem/offer.html';
                return;
            }
            if (key == "96e584784cb94c178ea397db3e409117") { // 大厂私教
                if (!this.userInfo || !this.userInfo.hasPhone) {
                    handleJumpUrl(key);
                } else {
                    privateEducationV2({
                        formId: "146",
                        subjectId: "-999",
                        referName: window && window.location.href || ''
                    }).then(res => {
                        const { state } = res || {}
                        if (state == 1) {
                            handleJumpUrl(key)
                        }
                    })
                }
            } else {
                handleJumpUrl(key)
            }
        },
        isActivityOver() {
            return new Date().getTime() > 1650902400000
        },
        eduPlatTrackFn(buttonName) {
            this.eduPlatTrack('WebButtonClick', {
                'page_id': 'b1tmk',
                'button_name': buttonName
            });
        },
        selectSubjectFn(subject) {
            this.selectedSubjectId = subject.subjectId;
        },
        openWeapp() {
            if (!this.isApp) {
                if (!Cookies.get('gate_login_token') && !Cookies.get('edu_gate_login_token')) {
                    return window.open('/frontLogin.do', '_self');
                }
                this.qrcodeModal = true;
                this.qrCodeImgUrl = this.qrCodeImg[this.selectedSubjectId - 1];
                return;
            }
            const path = `/pages/confession/index.html?from=${this.selectedSubjectId - 1}`;
            const userName = 'gh_5bc6c955d1db';
            const miniProgramType = this.isAndroid ? 0 : 1;
            const locationPath = encodeURIComponent(path);
            if (this.isEduApp) {
                const version = isBiggerThanSpecifiedVersion(getEduAppVersion(), '2.3.2');
                const bridgeTitle = this.isAndroid ? version ? 'lgedu' : 'lgeduapp' : 'lgedu';
                const bridgeUrl = `${bridgeTitle}://lgedu.com/miniProgram?userName=${userName}&path=${locationPath}&miniProgramType=${miniProgramType}`;
                window.location = bridgeUrl;
            } else if (this.isLgApp) {
                const lgBridgeTitle = this.isAndroid ? 'lgeduapp' : 'lagou';
                const lgPath = this.isAndroid ? path : locationPath;
                const lgBridgeUrl = `${lgBridgeTitle}://lagou.com/miniProgram?userName=${userName}&path=${lgPath}`;
                window.location = lgBridgeUrl;
                // 兼容非首页安卓打开小程序
                if (this.isAndroid) {
                window.location = `lagouapp://lagou.com/miniProgram?userName=${userName}&path=${lgPath}`;
                }
            }
            }
    },
}
</script>

<style lang="less" scoped>
.section {
    position: relative;
    display: flex;
    width: 100%;
    &.fixed {
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 99;
    }
    img {
        width: 100%;
    }
    .coupon-receive-left {
        position: absolute;
        bottom: 190px;
        left: 116px;
        width: 182px;
        height: 57px;
    }
    .coupon-receive-right {
        position: absolute;
        bottom: 190px;
        right: 116px;
        width: 182px;
        height: 57px;
    }
    .coupon-receive-middle {
        position: absolute;
        bottom: 190px;
        left: 50%;
        width: 182px;
        height: 57px;
        transform: translateX(-50%);
    }
    .order-btn {
        position: absolute;
        left: 50%;
        bottom: 36px;
        width: 640px;
        height: 84px;
        transform: translateX(-50%);
    }
    .add-btn {
        position: absolute;
        left: 50%;
        bottom: 80px;
        width: 640px;
        height: 84px;
        transform: translateX(-50%);
    }
    .subject-container {
        position: absolute;
        left: 50%;
        top: 354px;
        transform: translateX(-50%);
        width: 636px;
        height: 280px;
    }
    .subject-title {
        font-size: 28px;
        font-family: Source Han Sans SC;
        font-weight: 500;
        color: #9E4017;
        margin-top: 42px;
        text-align: center;
    }
    .subject-list {
        display: flex;
        margin-top: 27px;
        justify-content: space-around;
        flex-wrap: wrap;
        padding: 0 20px;
        box-sizing: border-box;
    }
    .subject-item {
        width: 190px;
        height: 67px;
        border: 2px solid transparent;
        border-radius: 32px;
        &.actived {
            border: 2px solid rgba(254, 119, 60, .4);
        }
        .subject-item-inner {
            width: 176px;
            height: 54px;
            line-height: 54px;
            text-align: center;
            background: linear-gradient(154deg, #FF961C, #FF6A5B);
            border-radius: 27px;
            font-size: 26px;
            font-family: Source Han Sans SC;
            font-weight: bold;
            color: #FFFFFF;
            margin: 6px auto 0;
        }
    }
    /deep/ .current-wrap {
        position: absolute;
        top: 342px;
        left: 71px;
        width: 608px;
        height: 579px;
        .swiper-slide {
            width: 8.1067rem;
            img {
                display: block;
                width: 8.1067rem;
                height: 7.72rem;
            }
        }
    }
}
.study-container {
    position: absolute;
    left: 49px;
    top: 150px;
    width: 653px;
    height: 887px;
    .study-img {
        position: absolute;
        width: 274px;
        &-1 {
            top: 167px;
            left: 33px;
        }
        &-2 {
            top: 167px;
            right: 32px;
        }
        &-3 {
            top: 385px;
            left: 33px;
        }
        &-4 {
            top: 385px;
            right: 32px;
        }
        &-5 {
            top: 601px;
            left: 33px;
        }
        &-6 {
            top: 601px;
            right: 32px;
        }
        &-7 {
            top: 816px;
            left: 33px;
        }
    }
}
.recevice-coupon {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 1, 31, .45);
    z-index: 999;
    .recevice-coupon-content {
        position: absolute;
        top: 45%;
        left: 50%;
        width: 600px;
        height: 550px;
        transform: translateX(-50%) translateY(-50%);
    }
    .recevice-coupon-wrap {
        width: 600px;
        height: 555px;
        background-color: #FF506D;
        border-radius: 12px;
        overflow: hidden;
        .recevice-coupon-img {
            display: block;
            width: 324px;
            height: 87px;
            margin: 92px auto 0;
        }
        .subject-list {
            display: flex;
            width: 557px;
            height: 212px;
            padding-top: 42px;
            margin: 47px auto 0;
            box-sizing: border-box;
            background-color: #db2140;
            border-radius: 4px;
            justify-content: center;
            flex-wrap: wrap;
            .subject-item {
                min-width: 113px;
                height: 54px;
                line-height: 54px;
                padding: 0 14px;
                box-sizing: border-box;
                font-size: 26px;
                color: #fff;
                text-align: center;
                margin-bottom: 27px;
                margin-right: 20px;
                background-color: #f17287;
                border-radius: 3px;
                &:nth-child(4) {
                    margin-right: 0;
                }
                &.actived {
                    background-color: #fd3e5e;
                }
            }
        }
    }
    .recevice-coupon-btn {
        position: absolute;
        bottom: -40px;
        left: 50%;
        width: 389px;
        height: 80px;
        line-height: 80px;
        text-align: center;
        border-radius: 40px;
        background: linear-gradient(166deg, #da0528, #FF506D);
        font-size: 36px;
        font-weight: bold;
        color: #fff;
        transform: translateX(-50%);
    }
    .close-btn {
        position: absolute;
        bottom: -140px;
        left: 50%;
        width: 70px;
        height: 70px;
        background: url("https://s21.lgstatic.com/growth/activity/20220328/1648455391724.png") no-repeat center;
        background-size: 70px 70px;
        transform: translateX(-50%);
    }
}
.recevice-success {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 1, 31, .45);
    z-index: 999;
    .recevice-content {
        position: absolute;
        top: 45%;
        left: 50%;
        width: 600px;
        height: 550px;
        transform: translateX(-50%) translateY(-50%);
        &-2 {
            height: 286px;
        }
    }
    .recevice-wrap {
        width: 600px;
        height: 286px;
        background-color: #FF506D;
        border-radius: 12px;
        overflow: hidden;
        padding: 0 30px;
        box-sizing: border-box;
        .recevice-img {
            display: block;
            width: 202px;
            height: 40px;
            margin: 92px auto 0;
            &-1 {
                display: block;
                width: 250px;
                height: 40px;
                margin: 75px auto 0;
            }
        }
        .recevice-txt {
            text-align: center;
            font-size: 26px;
            color: #fff;
            margin-top: 31px;
        }
    }
    .recevice-coupon-btn {
        width: 389px;
        height: 80px;
        line-height: 80px;
        text-align: center;
        border-radius: 40px;
        background: linear-gradient(166deg,  #da0528, #FF506D);
        font-size: 36px;
        font-weight: bold;
        color: #fff;
        margin: 30px auto 0;
    }
    .learn-btn {
        width: 389px;
        height: 80px;
        background: linear-gradient(166deg, #da0528, #FF506D);
        border-radius: 40px;
        margin: 39px auto 0;
        line-height: 80px;
        text-align: center;
        font-size: 36px;
        color: #fff;
        font-weight: bold;
    }
    .later-btn {
        margin-top: 32px;
        text-align: center;
        font-size: 30px;
        font-style: italic;
        color: #fff;
    }
    .close-btn {
        position: absolute;
        bottom: -70px;
        left: 50%;
        width: 70px;
        height: 70px;
        background: url("https://s21.lgstatic.com/growth/activity/20220328/1648455391724.png") no-repeat center;
        background-size: 70px 70px;
        transform: translateX(-50%);
    }
    .close-btn-2 {
        position: absolute;
        bottom: -110px;
        left: 50%;
        width: 70px;
        height: 70px;
        background: url("https://s21.lgstatic.com/growth/activity/20220328/1648455391724.png") no-repeat center;
        background-size: 70px 70px;
        transform: translateX(-50%);
    }
    .close-btn-3 {
        position: absolute;
        top: -106px;
        right: 0;
        width: 70px;
        height: 70px;
        background: url("https://s21.lgstatic.com/growth/activity/20220328/1648455391724.png") no-repeat center;
        background-size: 70px 70px;
    }
}
.qrcode-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 1, 31, .45);
    z-index: 999;
    .qrcode-content {
        position: absolute;
        top: 45%;
        left: 50%;
        width: 640px;
        height: 787px;
        transform: translateX(-50%) translateY(-50%);
        background: url("https://s21.lgstatic.com/growth/activity/20220510/1652153305277.png") no-repeat center;
        background-size: 640px 787px;
        .qrcode-img {
            position: absolute;
            top: 340px;
            left: 50%;
            width: 256px;
            height: 256px;
            transform: translateX(-50%);
        }
        .close {
            position: absolute;
            top: 30px;
            right: 30px;
            width: 21px;
            height: 21px;
        }
    }
}
</style>
